import { PollDetail } from 'src/lib/hooks/polls/useGetPollDetails';

export const POLL_TYPE_ENUM = {
  INTEGER: 'INTEGER',
  MULTIPLE: 'MULTIPLE',
  SINGLE: 'SINGLE',
  VOTE: 'VOTE',
};

export enum POLL_ANSWERED_STATE_ENUM {
  'INCORRECT' = 'incorrect',
  'CORRECT' = 'correct',
  'NOT_ATTEMPTED' = 'not attempted',
  'NONE' = '',
}

export enum RecordPollDisableFeatureList {
  FOOTER_SECTION = 'FOOTER_SECTION',
  THREE_DOT = 'THREE_DOT',
}

export enum VIDEO_PLAYER_POLL_TYPE_ENUM {
  LIVE = 'LIVE_POLL',
  NON_LIVE = 'NON_LIVE_POLL',
  RECORDED_POLL = 'RECORDED_POLLS',
}

export interface ScheduleRecordPollLocalStorageData {
  lastPollAttemptedId: string;
  pollAttemptedMap: PollAttemptedMap;
  userSelfResult: UserSelfResult;
  isPollFeedbackSubmitted: boolean;
}

export interface PollAttemptMarkOptions {
  correctOptions: string; // e.g., 'A'
  markOptions: string; // e.g., 'A,B'
}

export interface PollAttemptedMap {
  [pollId: string]: PollAttemptMarkOptions;
}

export interface UserSelfResult {
  totalAttemptPoll: number;
  totalCorrectPoll: number;
  averageTime: number;
  rank: number | null;
}

interface LeaderBoardUser {
  _id: string;
  firstName: string;
  lastName: string;
}

export interface LeaderBoardListItem {
  optionId: number[];
  pollId: string;
  timeTaken: string; // averageCorrectAnsweredTime in ms as string
  userId: string; // extracted from createdBy._id
  fullName: string; // createdBy.firstName + ' ' + createdBy.lastName
  pollEntityId: string;
  pollEntityType: string;
  createdAt: string;
  pointsEarned: number;
  rank: number;
}

export class LeaderBoardUserClass implements LeaderBoardUser {
  _id: string;
  firstName: string;
  lastName: string;

  constructor(data: LeaderBoardUser) {
    this._id = data._id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
  }
}

export class LeaderBoardListItemClass implements LeaderBoardListItem {
  optionId: number[];
  pollId: string;
  timeTaken: string;
  userId: string;
  fullName: string;
  pollEntityId: string;
  pollEntityType: string;
  createdAt: string;
  createdBy: LeaderBoardUserClass;
  pointsEarned: number;
  rank: number;

  constructor(data: any) {
    this.optionId = data.optionId;
    this.pollId = data.pollId;
    this.timeTaken = data.timeTaken;
    this.userId = data.createdBy._id;
    this.fullName = data.createdBy.firstName + ' ' + data.createdBy.lastName;
    this.createdBy = new LeaderBoardUserClass(data.createdBy);
    this.pollEntityId = data.pollEntityId;
    this.pollEntityType = data.pollEntityType;
    this.createdAt = data.createdAt;
    this.pointsEarned = data.pointsEarned;
    this.rank = data.rank;
  }
}

export class GenerateTop5LeaderBoardListModal {
  result: PollDetail;
  leaderboard: Array<LeaderBoardListItemClass> = [];
  constructor(data: any) {
    this.result = new PollDetail(data?.result);
    if (data && data.leaderboard && data.leaderboard.length > 0) {
      const leaderBoard: Array<LeaderBoardListItemClass> = data.leaderboard.map(
        (el: any) => new LeaderBoardListItemClass(el),
      );
      this.leaderboard = [...this.leaderboard, ...leaderBoard];
    }
  }
}

export enum PollStateEnum {
  POLL_START = 'POLL_START',
  STOP_EXPIRY = 'STOP_EXPIRY',
  RESULT = 'RESULT',
  NONE = '',
}

export const RECORD_POLL_DISABLE_HOT_KEYS: Record<string, boolean> = {
  Space: true,
  ArrowLeft: true,
  ArrowRight: true,
};
